import { IBHA } from './types'
/**
 * Calculate each BHA top/bottom based on bit_depth or final_md and BHA length.
 * @param BHAs
 * @param depth
 */
export function calculateBHA(BHAs: IBHA[], depth: number): IBHA[] {
    if (!Array.isArray(BHAs)) {
        return []
    }
    const bhaHeight = bhaLength(BHAs)
    let top = depth - bhaHeight
    const list = []
    for (const bha of BHAs) {
        const length = bha.length || 0
        const bottom = top + length
        list.push({
            ...bha,
            length,
            top,
            bottom
        })
        top = bottom
    }

    return list
}

/**
 * Return BHAs length.
 * @param BHAs
 * @return number BHA length
 */
export function bhaLength(BHAs: IBHA[]): number {
    return BHAs.reduce((size, bha) => size + bha.length || 0, 0)
}
//
// // TODO: move to pipes
// export function convert_unit(value: number, src: string, dest: string) {
//     if (src == 'm' && dest == 'ft') {
//         return parseFloat((value * 3.281).toFixed(2))
//     }
//     return value;
// }
//
